import { Entity } from '../../../core/context/entity';
import { UUID } from '../../../core/context/uuid/entity';
import { type AssetRelationAttributeData, type AssetRelationData } from './dto';

interface AssetRelationProps {
    id: string;
    name: string;
    sourceAssetId: string;
    targetAssetId: string;
    description?: string;
    assetRelationTypeId: string;
    attributes?: AssetRelationAttributeData[];
}

export class AssetRelation extends Entity {
    name: string;
    description?: string;
    sourceAssetId: string;
    targetAssetId: string;
    assetRelationTypeId: string;
    attributes: AssetRelationAttributeData[];

    constructor({
        id,
        name,
        description,
        sourceAssetId,
        targetAssetId,
        assetRelationTypeId,
        attributes,
    }: AssetRelationProps) {
        super({ id, name });
        this.name = name;
        this.description = description;
        this.sourceAssetId = sourceAssetId;
        this.targetAssetId = targetAssetId;
        this.assetRelationTypeId = assetRelationTypeId;
        this.attributes = attributes ?? [];
    }

    static new(props: Omit<AssetRelationData, 'id'>): AssetRelation {
        const uuid = new UUID();

        return new AssetRelation({
            ...props,
            id: uuid.toString(),
        });
    }
}
